import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { FaWhatsapp } from "react-icons/fa";
import "./PartDetail.css";

function PartDetail() {
  const { id } = useParams();
  const [part, setPart] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const { data: partData, error: partError } = await supabase
        .from("parts")
        .select("*")
        .eq("id", id)
        .single();

      if (!partError && partData) {
        if (typeof partData.compatible_vehicles === "string") {
          try {
            partData.compatible_vehicles = JSON.parse(partData.compatible_vehicles);
          } catch (e) {
            partData.compatible_vehicles = [];
          }
        }
        setPart(partData);
      }

      const { data: settingsData } = await supabase
        .from("site_settings")
        .select("exchange_rate")
        .limit(1)
        .single();

      if (settingsData) {
        setExchangeRate(settingsData.exchange_rate);
      }
    };

    fetchData();
  }, [id]);

  if (!part) {
    return <div className="container py-5 text-center">Yükleniyor...</div>;
  }

  const tlPrice = exchangeRate
    ? Math.ceil((part.euro * exchangeRate) / 50) * 50
    : "—";

  return (
    <div className="container py-5">
      <div className="row g-4">
        <div className="col-md-6">
          <div className="image-carousel">
            <img
              src={part.image_urls?.[currentImageIndex] || "/placeholder.jpg"}
              alt={part.name}
              className="main-image"
              style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
            />
            {part.image_urls?.length > 1 && (
              <div className="mt-2 text-center">
                <button
                  onClick={() =>
                    setCurrentImageIndex(
                      (currentImageIndex - 1 + part.image_urls.length) % part.image_urls.length
                    )
                  }
                >
                  ‹
                </button>
                <span style={{ margin: "0 10px" }}>
                  {currentImageIndex + 1} / {part.image_urls.length}
                </span>
                <button
                  onClick={() =>
                    setCurrentImageIndex((currentImageIndex + 1) % part.image_urls.length)
                  }
                >
                  ›
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="col-md-6">
          <h2>{part.name}</h2>
          {part.oem && (
            <p>
              <strong>OEM:</strong> {part.oem}
            </p>
          )}

          {part.compatible_vehicles?.length > 0 && (
            <>
              <h5>Uyumlu Araçlar</h5>
              <ul>
                {part.compatible_vehicles.map((v, i) => (
                  <li key={i}>
                    {v.brand} {v.model} ({v.yearFrom}–{v.yearTo})
                  </li>
                ))}
              </ul>
            </>
          )}

          {part.description && (
            <div
              className="mt-3"
              dangerouslySetInnerHTML={{ __html: part.description }}
            />
          )}

          <div className="mt-4 d-flex flex-wrap gap-3 align-items-center">
            <span style={{ fontWeight: 600, fontSize: "1.25rem" }}>
              Fiyat: ₺{tlPrice}
            </span>
            <a
              href={`https://wa.me/905337308779?text=${encodeURIComponent(
                `Merhaba, "${part.name}" parçası hakkında bilgi almak istiyorum.`
              )}`}
              className="btn btn-success"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="me-2" />
              WhatsApp ile İletişim
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartDetail;